import DOMPurify from 'dompurify';
import { cn } from '@/lib/utils';

const ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'em',
  'u',
  's',
  'ul',
  'ol',
  'li',
  'h1',
  'h2',
  'h3',
  'blockquote',
  'a',
];

const ALLOWED_ATTRIBUTES = ['href', 'title', 'target', 'rel'];

const RICH_TEXT_CLASSES =
  '[&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_li]:my-1 ' +
  '[&_p]:my-2 [&_h1]:text-lg [&_h1]:font-bold [&_h2]:text-base [&_h2]:font-bold ' +
  '[&_h3]:text-sm [&_h3]:font-bold [&_a]:text-zooprimary [&_a]:underline ' +
  '[&_blockquote]:border-l-2 [&_blockquote]:border-zooborder [&_blockquote]:pl-3 [&_blockquote]:text-zoomuted';

interface SafeHtmlProps {
  html: string;
  className?: string;
}

export function SafeHtml({ html, className }: SafeHtmlProps) {
  const sanitized = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ALLOWED_TAGS,
    ALLOWED_ATTR: ALLOWED_ATTRIBUTES,
  });
  return (
    <div
      className={cn('text-sm text-zooindigo leading-relaxed', RICH_TEXT_CLASSES, className)}
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
}
